<template>
  <div>
    <el-collapse v-model="activeName" class="collapse-main-content" v-if="voucherList[0]">
      <el-collapse-item v-for="(voucher, index) in voucherList" :key="voucher.id" :name="index">
        <template slot="title">
          <div class="collapse-title-pre"><span></span>{{ getVoucherTitle(voucher) }}</div>
          <el-button
            v-if="['3', 'S'].indexOf(voucher.syncFlag) == -1 && !voucher.reverseFlag"
            size="mini"
            type="primary"
            style="margin-left: 100px"
            v-hasPermi="['2021050814173010129']"
            @click.stop="editVoucher(voucher.id)"
            >修改凭证</el-button
          >
        </template>
        <div class="collapse-content">
          <baseEdit ref="baseEdit" :previewVoucher="'Y'" :voucherInfo="voucher"></baseEdit>
        </div>
      </el-collapse-item>
    </el-collapse>
    <div v-else class="dialog-footer vxe-button">暂无凭证</div>
    <!-- 冲销对话框 -->
    <el-dialog title="冲销信息" :visible.sync="dialogFormVisible" append-to-body>
      <base-form
        v-model="form"
        :options="options"
        ref="topData"
        :rules="rules"
        @input="handleChange"
        label-width="100px"
      >
      </base-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 过账信息 -生成凭证 确认按钮对话框 -->
    <el-dialog title="过账信息" :visible.sync="dialogAccountVisible" append-to-body>
      <base-form
        v-model="accoutForm"
        :options="accoutOptions"
        ref="accoutTopData"
        :rules="rules"
        @input="accoutHandleChange"
        label-width="100px"
      >
      </base-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogAccountVisible = false">取 消</el-button>
        <el-button type="primary" @click="accountConfirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  // import Vue from 'vue';
  import BaseForm from '@/components/form/base-form';
  import baseEdit from '@/pages/financeCenter/generalAccounting/voucher/voucherBaseEdit';
  export default {
    name: 'voucherComponent',
    components: {
      baseEdit,
      BaseForm,
    },
    data() {
      return {
        activeName: [],
        sapVoucherTypeList: [],
        dialogFormVisible: false, //冲销信息
        form: { reverseDate: null, reverseReason: null },
        dialogAccountVisible: false, //过账信息
        accoutForm: { postDate: null },
        formLabelWidth: '120px',
        currentDialogAccountFlag: '', //过账信息弹出框标识 handleAccountEntry 生成凭证弹出  doConfirm 确认按钮弹出
      };
    },
    props: {
      voucherList: {
        type: Array,
        default: () => [],
      },
    },
    computed: {
      options() {
        return [
          {
            type: 'dict',
            label: '冲销原因',
            prop: 'reverseReason',
            clearable: true,
            dictType: 'reverse_reason',
            disabled: false,
            required: true,
            span: 12,
          }, //冲销原因
          {
            type: 'date',
            label: '冲销日期',
            prop: 'reverseDate',
            clearable: true,
            disabled: false,
            required: this.form.reverseReason == '04',
            span: 12,
          }, //冲销日期
        ];
      },
      accoutOptions() {
        return [
          {
            type: 'date',
            label: '过账日期',
            prop: 'postDate',
            clearable: true,
            disabled: false,
            required: true,
            span: 12,
          }, //冲销日期
        ];
      },
      rules() {
        return {};
      },
    },
    mounted() {},
    methods: {
      // 冲销弹出框确认
      confirm() {
        this.$refs.topData
          .handleSubmit()
          .then(() => {
            this.dialogFormVisible = false;
            this.$emit('reverseInfo', this.form);
          })
          .catch(() => {});
      },
      //凭证/确认弹出框确认
      accountConfirm() {
        this.$refs.accoutTopData
          .handleSubmit()
          .then(() => {
            this.dialogAccountVisible = false;
            if (this.currentDialogAccountFlag == 'doConfirm') {
              // 确认
              this.$emit('doConfirmInfo', this.accoutForm);
            } else {
              // 生成凭证
              this.$emit('postInfo', this.accoutForm);
            }
          })
          .catch(() => {});
      },
      handleChange() {},
      accoutHandleChange() {},
      editVoucher(id) {
        let path = {
          path: `/generalAccounting/editVoucher`,
          name: 'editVoucher',
          meta: { keepAlive: true },
          query: {
            id,
            backRoute: JSON.stringify({
              path: this.$route.path,
              name: this.$route.name,
              query: this.$route.query,
            }),
          },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      getVoucherTitle(voucher) {
        let voucherNo = voucher.voucherNo
          ? this.$t('glVoucher.column.voucherNo') + ':' + voucher.voucherNo
          : '';
        let voucherType = voucher.voucherType
          ? this.$t('glVoucher.column.voucherType') + ':' + voucher.voucherType
          : '';
        let syncFlag = voucher.syncFlag
          ? this.$t('glVoucher.column.syncFlag') +
            ':' +
            (voucher.reverseFlag && voucher.reverseFlag != 'N'
              ? '已冲销'
              : this.$baseRequest.getDictValueByType('VOUCHERSYNFLAG', voucher.syncFlag))
          : '';
        let sapVoucherNo = voucher.sapVoucherNo
          ? this.$t('glVoucher.column.sapVoucherNo') + ':' + voucher.sapVoucherNo
          : '';
        return voucherNo + '      ' + voucherType + '      ' + syncFlag + '     ' + sapVoucherNo;
      },
    },
  };
</script>

<style scoped></style>
